module.exports = __webpack_public_path__ + "img/body-mindfulness-0.d4b24422.png";